import React, { useState, useContext, useEffect } from 'react'
import {
    handleRedirectInternal,
    mapData,
    jsonToFormData,
    currencyFormat,
} from '../../Product/common/components'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import AlertContext from '../../Product/context/alert/alertContext'
import ProductContext from '../../Product/context/product/productContext'
import PluginContext from '../../Product/context/plugin/pluginContext'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import Loader from '../../assets/loader'
import moment from 'moment'
import { setRef } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import Copy from '../../utils/CommonFunctionality/Share/Copy'

const RushPassHistory = () => {
    const authContext = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const pluginContext = useContext(PluginContext)
    const validationArray = Yup.object({})
    const [regBtnLoading, setRegBtnLoading] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [referralist, setReferralList] = useState([])
    const [referralListCount, setReferralListCount] = useState(0)
    const [page, setPage] = useState(1)

    const { user, loadUser, isAuthenticated, active_plugins, getActivePlugins } = authContext
    const { get_rushpass_list, responseStatus, rushpass_list, clearResponse } = pluginContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const history = useHistory()

    useEffect(() => {
        if (responseStatus && responseStatus !== '') {
            if (responseStatus.from === 'getReferralHistory') {
                // redeemEnablelist({
                //     site_id: global?.storeDetails?.site_id,
                //     user_id: user.id,
                // })
                setListLoading(false)
            }
        }
    }, [responseStatus])
    useEffect(() => {
        if (rushpass_list?.message && rushpass_list?.message?.results.length > 0) {
            setReferralList(rushpass_list?.message?.results)
            setReferralListCount(rushpass_list?.message?.results_cnt)
            setListLoading(false)
        } else {
            setListLoading(false)
            setRegBtnLoading(false)
        }
    }, [rushpass_list])
    useEffect(() => {
        setListLoading(true)
        const fetchReferralList = async () => {
            if (user) {
                const res = await get_rushpass_list({
                    site_id: global?.storeDetails?.site_id,
                    user_id: user.id,
                    page: page,
                    perlimit: 10,
                })
            }
        }
        fetchReferralList()
    }, [user, page])

    return (
        <div>
            {listLoading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : referralist.length > 0 ? (
                <>
                    <div className="table-responsive mt-4">
                        {
                            <table className="table table-hover mobile-table responisveTable">
                                <thead className="hidden-mobile">
                                    <tr>
                                        {/* <th></th> */}
                                        {/* <th className="numCell" role="id">
                                        Id
                                    </th> */}
                                        <th role="Code">Pass Code</th>
                                        <th role="Name">Pass Name</th>
                                        <th role="Invoice">Invoice</th>
                                        <th role="Price">Per Qty Price</th>
                                        <th role="Qty">Purchase Qty</th>
                                        <th role="Amt">Purchase Amount</th>
                                        <th role="Days">Total Days</th>
                                        <th role="Used">Used Days</th>
                                        <th role="Paid-Date">Paid Date</th>
                                        {/* <th role="RedeemDate">Redeem Date</th> */}
                                    </tr>
                                </thead>

                                <tbody>
                                    {referralist.length !== 0 &&
                                        referralist.map((item, index) => {
                                            return (
                                                <>
                                                    {item ? (
                                                        <tr key={index}>
                                                            {/* <td data-label="id">{item.id}</td> */}
                                                            {/* <td
                                                                data-label="S.no"
                                                                className="center"
                                                            >
                                                                {index + 1}
                                                            </td> */}
                                                            <td
                                                                data-label="pass_code"
                                                                className="center"
                                                            >
                                                                {item?.pass_code
                                                                    ? item?.pass_code
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-label="pass_name"
                                                                className="center"
                                                            >
                                                                {item?.name ? item?.name : '-'}
                                                            </td>
                                                            <td
                                                                data-label={'Invoice'}
                                                                className="center navLinkColor"
                                                                onClick={() => {
                                                                    if (item?.invoice_id !== 0) {
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            `invoice/buynow?id=${item.invoice_id}`,
                                                                        )
                                                                    }
                                                                }}
                                                            >
                                                                {item?.invoice_id !== 0
                                                                    ? item?.invoice_id
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-label="per_price"
                                                                className="center"
                                                            >
                                                                ${' '}
                                                                {item?.per_price
                                                                    ? item?.per_price
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-label="purchase_qty"
                                                                className="center"
                                                            >
                                                                {item?.purchase_qty
                                                                    ? item?.purchase_qty
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-label="purchase_amount"
                                                                className="center"
                                                            >
                                                                ${' '}
                                                                {item?.purchase_amount
                                                                    ? item?.purchase_amount
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-label="Total Days"
                                                                className="center"
                                                            >
                                                                {item?.qty ? item?.qty : '-'}
                                                            </td>
                                                            <td
                                                                data-label="Used Days"
                                                                className="center"
                                                            >
                                                                {item?.used_qty
                                                                    ? item?.used_qty
                                                                    : '-'}
                                                            </td>
                                                            <td
                                                                data-label="Date"
                                                                className="center"
                                                            >
                                                                {moment
                                                                    .utc(
                                                                        item?.date_add,
                                                                        'MM/DD/YYYY hh:mm:ss A',
                                                                    )
                                                                    .local()
                                                                    .format('dddd, MMMM DD, YYYY')}
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </>
                                            )
                                        })}
                                </tbody>
                            </table>
                        }
                    </div>
                    <Pagination
                        count={Math.ceil(referralListCount / 10)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </>
            ) : (
                <NoRecordsFound />
            )}
        </div>
    )
}

export default RushPassHistory
